import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LancamentosModule } from '@/mobile/modulos/lancamentos/LancamentosModule';

const searchSchema = z.object({
  /**
   * Pré-filtra a lista de lançamentos quando o usuário chega via Home > Pendências.
   * `pending` mapeia para tipo='pending' no LancSearchList.
   */
  filter: z.enum(['pending']).optional(),
});

export const Route = createFileRoute('/m/lancamentos')({
  validateSearch: (s) => searchSchema.parse(s),
  component: LancamentosModule,
});
